import { useSelector, useDispatch, useStore } from "react-redux";
import { useReactFlow } from "reactflow";
import { fotActions } from "../store/fot";
import utilIndex from "../views/thinking-layout-editor/utils";
import { getIt } from "@uikit/getIt";
import { CreatorNodesStore } from "@uiview/views/ProjectCanvas/store/CreatorNodesStore";

export default function useOpenAiParam() {
  const store = useStore();
  const dispatch = useDispatch();
  const creatorNodesStore = getIt(CreatorNodesStore);

  const variableList = useSelector(state => state.fot.variableList);
  const setVariableList = val => {
    dispatch(fotActions.setVariableList(val));
  };

  const getOpenAiParam = param => {
    const nodes = creatorNodesStore.getNodes();
    let { lineParams, prompt, nodeText } = param;

    prompt = utilIndex.replaceInputAndCustomVars({
      variableList,
      nodes,
      prompt,
      nodeText,
      isNode: true,
      setVariableList,
    });
    // const inputTestReg = /<input>/ig
    // const variableRegs = variableList.map(x => {
    //   const currentNode = nodes.find(y => y.id === x.node.id)
    //   const currentNodeTextAreaValue = currentNode?.data?.textAreaValue
    //   let recentValue = x.node.data.textAreaValue

    //   if (!util.isEmpty(currentNodeTextAreaValue)) {
    //     recentValue = currentNodeTextAreaValue
    //     // 更新variableList保存的textAreaValue
    //     const tempVariableList = [...variableList]
    //     const currVarIdx = tempVariableList.findIndex(y => y.name === x.name)
    //     tempVariableList.splice(currVarIdx, 1, {
    //       name: x.name,
    //       node: {
    //         ...x.node,
    //         data: {
    //           ...x.node.data,
    //           textAreaValue: currentNodeTextAreaValue
    //         }
    //       }
    //     })
    //     setVariableList([...tempVariableList])
    //   }

    //   return {
    //     reg: new RegExp(`<${x.name}>`, 'g'),
    //     value: recentValue || ''
    //   }
    // })
    // // 匹配自定义变量并替换值
    // if (!util.isEmpty(variableRegs)) {
    //   variableRegs.forEach(x => {
    //     prompt = prompt.replace(x.reg, x.value)
    //   })
    // }
    // // 替换<input>变量
    // if (inputTestReg.test(prompt)) {
    //   prompt = prompt.replace(inputTestReg, nodeText)
    // } else {
    //   prompt = `${prompt}${nodeText}`
    // }

    return {
      engine: lineParams.engine,
      frequency_penalty: lineParams.frequencyPenalty,
      max_tokens: lineParams.maxTokens,
      presence_penalty: lineParams.presencePenalty,
      stop: lineParams.stopSequences,
      temperature: lineParams.temperature,
      prompt: prompt,
    };
  };

  const getCompletionsGenerationParam = async (
    identifierType,
    identifierValue,
    variable,
    streaming = true,
    instantIntentDomain = ""
  ) => {
    const customVariable = {};
    const postParam = {
      identifier_type: identifierType,
      identifier_value: identifierValue,
      stream: streaming,
    };
    if (identifierType === "file" && instantIntentDomain) {
      postParam.domain = instantIntentDomain;
    }

    if (identifierType === "object_id") {
      const variableList = store.getState().fot.variableList;
      variableList.forEach(x => {
        customVariable[x.name] = x.node.data.textAreaValue;
      });
    }
    const combinedVariables = Object.assign({}, { ...variable }, { ...customVariable });
    const stringifiedVariables = {};
    Object.entries(combinedVariables).forEach(x => {
      const key = x[0];
      const val = x[1];
      stringifiedVariables[key] = typeof val !== "string" ? JSON.stringify(val) : val;
    });
    postParam.variables = stringifiedVariables;
    return postParam;
  };
  return { getOpenAiParam, getCompletionsGenerationParam };
}
